"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCarrierOilUpdateInputSchema = exports.APosCarrierOilCreateInputSchema = exports.APosCarrierOilSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
const oil_blending_stock_schema_1 = require("./oil-blending-stock.schema");
const fragrance_schema_1 = require("./fragrance.schema");
/**
 * Module 29 — Oil Blending
 * Carrier oil catalog (FCO, Jojoba, etc.). PK = tenantId, SK = carrierOilId.
 *
 * STOCK MODEL — 2026-06-04 redesign:
 * Same pattern as Fragrance — `stock_by_location` map on the row, mL only,
 * never a Variant. `linked_variant_id` is legacy and kept for migration.
 */
const decimal3dp = (val) => Number.isFinite(val) && Math.round(val * 1000) / 1000 === val;
const decimal4dp = (val) => Number.isFinite(val) && Math.round(val * 10000) / 10000 === val;
exports.APosCarrierOilSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    carrierOilId: id_schema_1.EntityIdSchema.describe('Format: carr_{ulid12}'),
    name: zod_1.z.string().min(1).max(120),
    description: zod_1.z.string().max(2000).optional(),
    cost_per_ml: zod_1.z.number().nonnegative().refine(decimal4dp, 'must be 4dp'),
    // Symmetric with Fragrance so premium carriers (organic, cold-pressed)
    // can be tiered. Default 'standard' means use the global multiplier.
    markup_tier: fragrance_schema_1.APosFragranceMarkupTierSchema.default('standard').optional(),
    markup_override: zod_1.z.number().nonnegative().optional(),
    reorder_threshold_ml: zod_1.z.number().nonnegative().refine(decimal3dp, 'must be 3dp'),
    supplier: zod_1.z.string().max(200).optional(),
    brand_id: id_schema_1.EntityIdSchema.optional(),
    image_url: zod_1.z.string().url().optional(),
    internal_barcode: zod_1.z.string().max(64).optional(),
    is_active: zod_1.z.boolean().default(true),
    is_visible_to_customers: zod_1.z.boolean().default(true),
    stock_by_location: oil_blending_stock_schema_1.APosIngredientStockByLocationSchema.default({}),
    linked_variant_id: id_schema_1.EntityIdSchema.optional().describe('LEGACY — pre-2026-06-04 records only.'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosCarrierOilCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(120),
    description: zod_1.z.string().max(2000).optional(),
    cost_per_ml: zod_1.z.number().nonnegative().refine(decimal4dp, 'must be 4dp'),
    markup_tier: fragrance_schema_1.APosFragranceMarkupTierSchema.optional(),
    markup_override: zod_1.z.number().nonnegative().optional(),
    reorder_threshold_ml: zod_1.z.number().nonnegative().refine(decimal3dp, 'must be 3dp'),
    supplier: zod_1.z.string().max(200).optional(),
    brand_id: id_schema_1.EntityIdSchema.optional(),
    image_url: zod_1.z.string().url().optional(),
    internal_barcode: zod_1.z.string().max(64).optional(),
    is_active: zod_1.z.boolean().optional(),
    is_visible_to_customers: zod_1.z.boolean().optional(),
});
exports.APosCarrierOilUpdateInputSchema = exports.APosCarrierOilCreateInputSchema.partial();
//# sourceMappingURL=carrier-oil.schema.js.map